import { useEffect, useState } from "react";
import { Button, Flex } from "@chakra-ui/react";
import TableList from "components/TableList";
import DropDown from "components/DropDown";
import { useNavigate } from "react-router-dom";
import { toaster } from "components/ui/toaster";
import { api } from "services/api";
import { GoSync } from "react-icons/go";
import constant from "constant";
import PaginationComp from "components/PaginationComp";
import utils from "utils";
import SearchInput from "components/SearchInput";
import { Header } from "components/Header";
import Modal from "components/Modal";
import Notify from "./Notify";
import PopOverComp from "components/PopOverComp";
import InputComp from "components/InputComp";
import storage from "utils/storage";
import ButtonComp from "components/Button";
import DeleteConfim from "components/DeleteConfim";

const headers = [
  "Claim Number",
  "Admin",
  "State",
  "Retailer",
  "Policy",
  "Created",
  "Paid",
  {
    label: "Amount",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },
  "Details",
  // "Actions",
];

const paidId = utils.getStateId("Paid", "claim");

function Claims() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpNotifyFrom, setIsModalOpNotifyFrom] = useState(false);
  const [notifyType, setNotifyType] = useState("");
  const [notifyView, setNotifyView] = useState(false);

  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState();

  const [claimStatusDD, setClaimStatusDD] = useState([]);
  const [filerLast, setFilerLast] = useState([]);
  const [dealers, setDealers] = useState();
  const [claimHisData, setClaimHisData] = useState([]);
  // const [policyTypes, setPolicyTypes] = useState();

  const [activePage, setActivePage] = useState(1);
  const [searchTxt, setSearchTxt] = useState("");

  const onRefresh = () => {
    getList({
      page: 1,
      // dealerid: utils.getDealerid(dealers),
      // limitId: utils.getLimitId(filerLast),
      searchTxt: searchTxt,
    });
  };

  const onDelete = async () => {
    const stateid = selectedItem?.item?.data?.state;

    if (stateid === paidId) {
      window.alert("paid status cannot delete");
      return;
    }
    // window.alert(`deleteded  (${stateid} ${paidId})`);
    // return;
    if (selectedItem?.item?.data?.claimid) {
      setIsLoading(true);
      const res = await api.deleteClaim({
        claimid: selectedItem?.item?.data?.claimid,
        claimnumber: selectedItem?.item?.data?.claimnumber,
      });
      setIsLoading(false);
      console.log("getAgreementPrint", res);
      if (res?.status === 200) {
        onRefresh();
        toaster.create({
          title: res?.message || "success",
          type: "success",
        });
      } else {
        toaster.create({
          title: res?.message || "fail",
          type: "error",
        });
      }
    }
  };

  const onPolicyPrint = async () => {
    setIsLoading(true);
    const res = await api.getAgreementPrint({
      policyid: selectedItem?.item?.data?.policyid,
    });
    setIsLoading(false);
    console.log("getAgreementPrint", res);
    if (res?.status === 200) {
      if (res?.data?.file?.type === "pdf" && res?.data?.file?.stream) {
        // console.log(res?.data?.file?.stream || "");
        let pdf = {
          file: `data:application/pdf;base64,${res?.data?.file?.stream}`,
          file_name: res?.data?.file?.name || "AU_Warranties_Agreement",
        };

        const pdfLink = `${pdf.file}`;
        const anchorElement = document.createElement("a");
        const fileName = `${pdf.file_name}.pdf`;
        anchorElement.href = pdfLink;
        anchorElement.download = fileName;
        anchorElement.click();
      }
      return;
    }
    toaster.create({
      title: res?.message || "fail",
      type: "error",
    });
    return;
  };

  const onClaimPrint = async () => {
    setIsLoading(true);
    const res = await api.getClaimPrint({
      claimid: selectedItem?.item?.data?.claimid,
    });
    setIsLoading(false);
    console.log("getAgreementPrint", res);
    if (res?.status === 200) {
      if (res?.data?.file?.type === "pdf" && res?.data?.file?.stream) {
        // console.log(res?.data?.file?.stream || "");
        let pdf = {
          file: `data:application/pdf;base64,${res?.data?.file?.stream}`,
          file_name: res?.data?.file?.name || "AU_Warranties_Claim",
        };

        const pdfLink = `${pdf.file}`;
        const anchorElement = document.createElement("a");
        const fileName = `${pdf.file_name}.pdf`;
        anchorElement.href = pdfLink;
        anchorElement.download = fileName;
        anchorElement.click();
      }
      return;
    }
    toaster.create({
      title: res?.message || "fail",
      type: "error",
    });
    return;
  };

  const onClickPrint = (data) => {
    console.log("onClickPrint", data);

    if (data?.value === "claimpdf") {
      onClaimPrint();
    } else if (data?.value === "policypdf") {
      onPolicyPrint();
    }
  };

  const onClickNotify = (data) => {
    setIsModalOpNotifyFrom(true);
    setNotifyType(data?.value);
  };

  const onClickNew = () => {
    navigate("/claimview", {
      state: {
        action: "claim-add",
        data: {},
      },
    });
  };

  const onClickOpen = () => {
    navigate("/claimview", {
      state: {
        action: "claim-edit",
        data: {
          itemData: selectedItem?.item?.data,
        },
      },
    });
  };

  const onClickHistory = () => {
    console.log("onClickHistory", selectedItem?.item?.data?.claimid);

    setIsLoading(true);
    api
      .getClaimHistory({
        claimid: selectedItem?.item?.data?.claimid,
      })
      .then((res) => {
        setIsLoading(false);

        if (res?.status === 200) {
          const statesList = { ...constant.claimStateColor };

          console.log("getClaimHistory = ", res?.data);
          if (res?.data && res?.data[0]?.claimid) {
            setClaimHisData(
              res?.data?.map((a, index) => ({
                id: `claimhis-${index}`,
                "Date/Time": utils.formatToDDMMYYYY(a?.historydate),
                Operator: a?.operatorname || "",
                // Status: a?.statusid,
                Status:
                  a?.statusid && statesList && statesList[a.statusid].statename
                    ? statesList[a?.statusid]?.statename
                    : "",
                Description: a?.description,
              }))
            );
          } else {
            setClaimHisData([]);
          }
          setIsModalOpen(true);
        } else {
          toaster.create({
            title:
              res?.response?.data?.message ||
              res?.data?.message ||
              res?.message,
            type: "error",
          });
        }
      });
  };

  const onSelectItm = (data) => {
    // console.log("onSelectItm", data);
    setSelectedItem(data);
    if (data?.item?.data?.state) {
      utils.getCliamStatusDD({
        setClaimStatusDD,
        defaultVal: data?.item?.data?.state,
      });
    }
  };

  const getList = (data) => {
    const appcatch = storage.get("appcatch") || {};
    console.log("getList appcatch", appcatch);

    const stext = data?.searchTxt === undefined ? searchTxt : data.searchTxt;

    // if (stext) {
    //   setSearchLoading(true);
    // }

    const pl = {
      dealerid: appcatch.claims_dealerid, //data?.dealerid,
      searchTxt: stext,
      limitId: appcatch?.claims_limitkey, //|| data?.limitId || getLimitId(filerLast),
      page: data?.page || activePage,
    };

    if (!pl.limitId) {
      console.log("err getList limitId null");
      setList([]);
      return;
    }

    if (!pl.dealerid) {
      console.log("err getList dealerid null");
      setList([]);
      return;
    }

    setIsLoading(true);
    api.getClaims(pl).then((res) => {
      console.log("getClaims = ", res);
      setIsLoading(false);

      // if (stext) {
      //   setSearchLoading(true);
      // }

      if (res?.status === 200) {
        if (data?.page) {
          setActivePage(data.page);
        }

        if (res?.data && res?.data[0]?.claimid) {
          const statesColor = { ...constant.claimStateColor };
          setList(
            res.data.map((item) => {
              let det = "";
              if (item?.failedpart) {
                det += item.failedpart;
              }

              if (item?.failedarea) {
                det += " ";
                det += item.failedarea || "";
              }

              if (item?.failurecause) {
                det += " ";
                det += item.failurecause || "";
              }

              if (item?.repairsrequired) {
                det += " ";
                det += item.repairsrequired || "";
              }

              return {
                id: item?.claimid,
                ClaimNumber: item?.claimnumber,
                Admin: item?.claimadmin || "",
                State: {
                  clr:
                    statesColor && statesColor[item?.state]?.clr
                      ? statesColor[item?.state].clr
                      : "gray",
                  label: item?.statename || "",
                },
                // State: statesColor[item?.state]?.clr
                //   ? {
                //       clr:
                //         statesColor && statesColor[item?.state]?.clr
                //           ? statesColor[item?.state].clr
                //           : undefined,
                //       label: item?.statename || "",
                //     }
                //   : item?.statename || "",

                Retailer: item?.companyname || "",
                Policy: item?.policynumber,
                Created: item?.dateclaim
                  ? utils.formatToDDMMYYYY(item?.dateclaim)
                  : "",
                Paid: item?.paiddate
                  ? utils.formatToDDMMYYYY(item?.paiddate)
                  : "",
                Amount: utils.formatAmountForTb(item?.claimtotal),
                Details: det,
                data: item,
                // Actions: item?.repairsrequired,
              };
            })
          );
        } else {
          setList([]);
        }
      } else {
        setList([]);
        toaster.create({
          title:
            res?.response?.data?.message || res?.data?.message || res?.message,
          type: "error",
        });
      }
      // if (data.searchTxt !== undefined) {
      //   setSearchLoading(false);
      // }
    });
  };

  const onchangeFlLast = (data) => {
    console.log("onchangeFlLast", data);

    if (data?.item?.key) {
      const appcatch = storage.get("appcatch") || {};
      appcatch.claims_limitkey = data?.item?.key;
      storage.set("appcatch", appcatch);

      setFilerLast([...data.list]);
      getList({
        page: 1,
        // limitId: data.item?.key,
        // dealerid: utils.getDealerid(dealers),
      });
    }
  };

  const onDealersChange = (data) => {
    console.log("onDealersChange data", data);

    const appcatch = storage.get("appcatch") || {};
    appcatch.claims_dealerid = data?.item?.data?.dealerid;
    storage.set("appcatch", appcatch);

    setDealers(data?.list ? [...data.list] : []);
    // if (data?.item?.data?.dealerid || data?.item?.data?.dealerid === 0) {

    getList({
      // dealerid: data?.item?.data?.dealerid,
      page: 1,
    });

    // } else {
    // getList();
    // }
  };

  const onChangeClaimStDD = async (data) => {
    setSelectedItem();
    console.log("onChangeClaimStDD", {
      selectedItem,
      data,
    });

    // extract id
    // const stateid = data?.item?.data?.stateid;

    setIsLoading(true);
    return api
      .updateClaimsstate({
        claimid: selectedItem?.item?.data?.claimid, //selectedItem?.item?.data?.claimid,
        stateid: data?.item?.data?.stateid,
        description: "",
      })
      .then((res) => {
        setIsLoading(false);
        if (res?.status === 200) {
          onRefresh();
          setClaimStatusDD(data?.list || []);
        } else {
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });

    // setDealers(data?.list ? [...data.list] : []);
    // if (data?.item?.data?.dealerid || data?.item?.data?.dealerid === 0) {
    //   getList({
    //     dealerid: data?.item?.data?.dealerid,
    //   });
    // } else {
    //   getList();
    // }
  };

  const onChangeSearchTxt = (v) => {
    setSearchTxt(v);
    getList({
      searchTxt: v,
      page: 1,
      // limitId: utils.getLimitId(filerLast),
      // dealerid: utils.getDealerid(dealers),
    });

    // getList({ searchTxt: v, dealerid: utils.getDealerid(dealers) });
    // setSearchLoading(true);
  };

  // const onChangePolicyTypes = (data) => {
  //   setPolicyTypes([...data.list]);
  //   if (data?.item?.data?.coverid) {
  //     getList({
  //       coverid: data.item.data.coverid,
  //     });
  //   }
  // };

  const onChangePage = (data) => {
    if (data?.page === activePage) {
      return;
    }
    getList({
      page: data.page,
      // limitId: utils.getLimitId(filerLast),
      searchTxt: searchTxt,
      // dealerid: utils.getDealerid(dealers),
    });
  };

  // const getPolicyTypes = (data) => {
  //   api.getPolicyTypes().then((res) => {
  //     console.log("getPolicyTypes =", res);
  //     if (res?.status === 200) {
  //       if (res?.data && res?.data[0]) {
  //         const arr = res.data.map((a, index) => ({
  //           key: `policytype-${index}`,
  //           value: `${a.covername}-${index}`,
  //           label: a.covername,
  //           data: a,
  //         }));
  //         arr[0].selected = true;
  //         // setPolicyTypes(arr);
  //         getList({
  //           dealerid: data?.dealerid,
  //           coverid: arr[0]?.data?.coverid,
  //         });
  //       }
  //     } else {
  //       toaster.create({
  //         title: res?.message,
  //         type: "error",
  //       });
  //     }
  //   });
  // };

  // const getDealers = async () => {
  //   setIsLoading(true);
  //   return api.getDealers().then((res) => {
  //     console.log("getDealers =", res);
  //     setIsLoading(false);
  //     if (res?.status === 200) {
  //       if (res?.data && res?.data[0]) {
  //         const dea = res.data.map((a, index) => ({
  //           key: `dealer-${index}`,
  //           value: `${a?.companyname}-${index}`,
  //           label: a?.companyname,
  //           data: { dealerid: a?.dealerid },
  //         }));

  //         const arr = [
  //           {
  //             key: "dealer-all",
  //             value: "all",
  //             label: "All",
  //             data: { dealerid: 0 },
  //           },
  //           ...dea,
  //         ];

  //         arr[0].selected = true;
  //         onDealersChange({
  //           index: 0,
  //           item: arr[0],
  //           list: arr,
  //         });

  //         // setDealers(arr);
  //         // getList({
  //         // dealerid: arr[0]?.data?.dealerid,
  //         // });
  //         // getPolicyTypes({ dealerid: arr[0].data.dealerid });
  //       } else {
  //         onDealersChange();
  //       }
  //     } else {
  //       toaster.create({
  //         title: res?.message,
  //         type: "error",
  //       });
  //     }
  //   });
  // };

  // const getCliamStatus = () => {
  //   const claimStatusList = Object.values(constant.claimStateColor);
  //   const arr = Array.from(
  //     Object.keys(constant.claimStateColor),
  //     (k) => constant.claimStateColor[`${k}`]
  //   );
  //   console.log(arr);
  //   console.log("claimStatusList", claimStatusList);
  //   claimStatusList[0].selected = true;
  //   setClaimStatusDD(
  //     claimStatusList.map((a, index) => ({
  //       key: `claimStatus-${index}`,
  //       value: a?.statename + "-" + index,
  //       label: a?.statename,
  //       data: a,
  //     }))
  //   );
  // };

  const getPermNotify = async () => {
    setIsLoading(true);
    return api
      .getHaspermission({ permvalue: ["perm_policy_email"] })
      .then((res) => {
        console.log("getPermNotify getHaspermission res", res);
        setIsLoading(false);
        if (res?.status === 200) {
          if (res?.data?.perm_policy_email === true) {
            setNotifyView(true);
          }
        }
        // else if (res?.status === 403) {
        //   setNotifyView(false);
        // }
        else {
          setNotifyView(false);
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  useEffect(() => {
    utils.getCliamStatusDD({
      setClaimStatusDD,
    });
    onSelectItm();
  }, [list]);

  useEffect(() => {
    const cd = async () => {
      const appcatch = storage.get("appcatch") || {};

      utils.getCliamStatusDD({
        setClaimStatusDD,
      });

      await getPermNotify();
      await utils.getDealers({
        setIsLoading,
        action: "useState",
        onDealersChange,
        defaultVal: appcatch?.claims_dealerid,
      });

      utils.getLimitDD({
        onChangeFlLast: onchangeFlLast,
        defaultVal: appcatch?.claims_limitkey,
      });
    };
    cd();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Claims"} isLoading={isLoading} />
      <Modal
        isopen={isModalOpen}
        type="table"
        items={claimHisData}
        title={"Claim History"}
        setIsOpen={setIsModalOpen}
        size={"xl"}
      />

      <Modal
        isopen={isModalOpNotifyFrom}
        Child={Notify}
        title={"Notify"}
        setIsOpen={setIsModalOpNotifyFrom}
        childData={{
          itemData: selectedItem?.item?.data,
          type: notifyType,
          setIsLoading,
        }}
      />
      <Flex
        width={"100%"}
        flexFlow={"wrap"}
        gap={"1rem"}
        alignItems={"center"}
        mb={"1rem"}
      >
        <DeleteConfim
          onDelete={onDelete}
          TrigarComp={
            <ButtonComp
              keyname="delete-ic-2"
              disabled={
                !selectedItem ||
                isLoading ||
                selectedItem?.item?.data?.state === paidId
              }
            />
          }
        />

        <InputComp
          type={"dropdown"}
          items={filerLast}
          onChange={onchangeFlLast}
          keyname={"last-filter"}
          placeholder={"Select Limit"}
        />
        {/* <DropDown w={"10rem"} items={filerLast} onChange={onchangeFlLast} /> */}
        <DropDown
          // w={"15rem"}
          items={dealers}
          onChange={onDealersChange}
          placeholder={"Select Account"}
        />
        <InputComp
          type={"dropdown"}
          items={claimStatusDD}
          onChange={onChangeClaimStDD}
          placeholder={"Change State"}
          disabled={!selectedItem}
          keyname={"claim-state"}
        />

        {/* <DropDown
          // w={"15rem"}
          items={claimStatusDD}
          onChange={onChangeClaimStDD}
          disabled={!selectedItem}
          placeholder={"Change State"}
        /> */}
        <Button
          onClick={onClickHistory}
          variant="outline"
          disabled={!selectedItem}
        >
          History
        </Button>
        <Button onClick={onRefresh} variant="outline" disabled={isLoading}>
          <GoSync />
        </Button>
        {/* <DropDown
          w={"15rem"}
          items={policyTypes}
          onChange={onChangePolicyTypes}
        /> */}
        <Flex flex={1} />
        {/* <Flex flexFlow={"wrap"} alignItems={'center'} gap={'2rem'}> */}
        {/* <Field.Label textStyle={fs}>Town</Field.Label> */}
        <Button
          disabled={!selectedItem}
          onClick={onClickOpen}
          variant="outline"
        >
          Open
        </Button>
        <Button onClick={onClickNew} variant="outline">
          New
        </Button>

        {/* <Button
          display={notifyView ? "flex" : "none"}
          variant="outline"
          onClick={onClickNotify}
          disabled={!selectedItem}
        >
          Notify
        </Button> */}

        <PopOverComp
          // display={notifyView ? "flex" : "none"}
          onSelect={onClickPrint}
          items={constant.claimsPrintBtnList}
          Body="selectlist"
          TriggerComp={
            <Button variant="outline" disabled={!selectedItem || isLoading}>
              Print
            </Button>
          }
        />

        <PopOverComp
          display={notifyView ? "flex" : "none"}
          onSelect={onClickNotify}
          items={constant.notifyList}
          Body="selectlist"
          TriggerComp={
            <Button variant="outline" disabled={!selectedItem || isLoading}>
              Notify
            </Button>
          }
        />
        <SearchInput onChange={onChangeSearchTxt} />
      </Flex>
      {/* <Flex justifyContent="space-between" gap={"3"}> */}
      {/* </Flex> */}

      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        onSelect={onSelectItm}
        selectedItem={selectedItem}
      />
      <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
        limit={utils.getLimitId(filerLast)}
      />
    </Flex>
  );
}

export default Claims;
